var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marketplace-card-wrapper"},[_c('h2',[_vm._v("Marketplace")]),_c('MarketplaceSystems',{staticClass:"iqos iqos-long"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }